export const FIT_DEFAULT = { mode: "fill", zoom: 1, x: 50, y: 50 };

export function LogoImg({ src, fit, alt, className = "", style, testId }) {
  const f = { ...FIT_DEFAULT, ...(fit || {}) };
  if (f.mode === "fit") {
    return (
      <span style={style} className={`${className} relative block overflow-hidden bg-white`} data-testid={testId}>
        <img src={src} alt={alt} draggable={false} className="absolute inset-[8%] h-[84%] w-[84%] select-none object-contain" />
      </span>
    );
  }
  return (
    <span style={style} className={`${className} relative block overflow-hidden`} data-testid={testId}>
      <img src={src} alt={alt} draggable={false} className="absolute inset-0 h-full w-full select-none object-cover"
        style={{ objectPosition: `${f.x}% ${f.y}%`, transform: `scale(${f.zoom})`, transformOrigin: `${f.x}% ${f.y}%` }} />
    </span>
  );
}
